/**
 * Provider company-profile endpoints (including the professions the company
 * hires for).
 */
export function useCompany() {
  const { apiFetch } = useApi()

  async function get<T = any>(): Promise<T> {
    const res = await apiFetch<{ data: T }>('/company')
    return res.data
  }

  async function save<T = any>(payload: Record<string, unknown>): Promise<T> {
    const res = await apiFetch<{ data: T }>('/company', {
      method: 'PUT',
      body: payload,
    })
    return res.data
  }

  async function uploadLogo<T = any>(file: File): Promise<T> {
    const form = new FormData()
    form.append('logo', file)
    const res = await apiFetch<{ data: T }>('/company/logo', {
      method: 'POST',
      body: form,
    })
    return res.data
  }

  async function removeLogo<T = any>(): Promise<T> {
    const res = await apiFetch<{ data: T }>('/company/logo', { method: 'DELETE' })
    return res.data
  }

  return { get, save, uploadLogo, removeLogo }
}
